import { useState } from 'react';
import Head from 'next/head';
import Navigation from './Navigation';
import ChatbotWidget from '../common/ChatbotWidget';
import StudentUploadJobWatcher from '../common/StudentUploadJobWatcher';

const DashboardLayout = ({ children, title = 'Dashboard - Gyan Sathi' }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <div className="min-h-screen bg-gray-50">
        <Navigation 
          sidebarOpen={sidebarOpen} 
          setSidebarOpen={setSidebarOpen} 
        />
        <main className="lg:pl-64 min-h-screen pt-16 lg:pt-0">
          <div className="p-4 lg:p-8">
            {children}
          </div>
        </main>
        <ChatbotWidget />
        <StudentUploadJobWatcher />
      </div>
    </>
  );
};

export default DashboardLayout;